import { Link } from 'react-router-dom'

export default function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-3xl font-bold text-secondary-900 mb-2">Terms of Service</h1>
      <p className="text-sm text-secondary-500 mb-10">Effective Date: July 2025</p>

      <div className="prose prose-secondary max-w-none space-y-8 text-secondary-700 leading-relaxed">
        <p>LinkZon is operated in Sweden.</p>

        <section>
          <h2 className="text-xl font-semibold text-secondary-900 mb-3">1. Platform Role</h2>
          <p>
            LinkZon is a digital intermediary facilitating contact between Experts and Clients. The platform does not provide healthcare or medical treatment.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-secondary-900 mb-3">2. Independent Experts</h2>
          <p>
            Experts operate as independent contractors and are solely responsible for accuracy of credentials, legal compliance, and tax obligations.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-secondary-900 mb-3">3. Payments</h2>
          <p>
            Payments are processed through third-party payment providers (e.g., Stripe). Platform service fees may apply.
          </p>
          <p>
            Users agree not to circumvent the platform for transactions initiated through LinkZon.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-secondary-900 mb-3">4. Limitation of Liability</h2>
          <p>
            LinkZon is not liable for disputes between users. Users engage at their own risk.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-secondary-900 mb-3">5. Governing Law</h2>
          <p>
            These Terms are governed by Swedish law.
          </p>
        </section>

        <hr className="my-10 border-secondary-200" />

        <div className="flex items-center gap-6 text-sm">
          <Link to="/privacy" className="text-accent-600 hover:text-accent-700 font-medium">Privacy Policy</Link>
          <Link to="/about" className="text-accent-600 hover:text-accent-700 font-medium">About</Link>
          <a href="mailto:connect@linkzon.se" className="text-accent-600 hover:text-accent-700 font-medium">Contact: connect@linkzon.se</a>
        </div>
      </div>
    </div>
  )
}
